const OccurrenceTypes = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  AMOUNT: 'amount',
};

export { OccurrenceTypes }; // eslint-disable-line import/prefer-default-export
